skrilla.directive('promotionCodes',function() {
    return {
        templateUrl: 'directives/promotionCodes/promotionCodes.html',
        scope: {
            promotionDefinition: "=",
            affiliate: "="
        },
        controller: function($scope, searchService, cacheService, modalService, srefService){
            $scope.isDefinitionView = ($scope.promotionDefinition !== undefined && $scope.promotionDefinition !== null);
            var url = $scope.isDefinitionView ? "promotions/definitions/" + $scope.promotionDefinition.id + "/codes" : "affiliates/" + $scope.affiliate.id + "/codes";

            $scope.search = function(){
                searchService.get(url).then(function (response) {
                    $scope.codes = response.data;
                });
            }
            $scope.search()

            if($scope.isDefinitionView && $scope.promotionDefinition.purpose === "PROMOTION"){
                cacheService.registerObject("promotionCodesUpdateFn", $scope.search)
            }

            $scope.gotoOwner = function(code){
                var location = code.ownerType === "USER" ? "userDetails" : "affiliateDetails";
                srefService.go(location, {id: code.ownerId});
            }

            $scope.create = function(){
                cacheService.registerObject("promotionDefinition", $scope.promotionDefinition)
                modalService.openModal("views/createAffiliateCode/createAffiliateCode.html", true, 'lg', true, true, function(){
                    $scope.search()
                })
            }

            $scope.route = function(code){
                srefService.go("promotionCodeAndClaims", {id: code.id})
            }

        }
    };
});
